import { useContextState } from "../../../../hooks/theme"

export const useStyles = () => {
    const { colors } = useContextState()
    return {
        topContainer: {
            backgroundColor: "#fafafa",
            p: '16px 16px 0 16px'
        },
        mainContainer: (hasItems: boolean) => ({
            marginBottom: 2,
            padding: 1,
            color: colors.color9,
            display: 'flex',
            gap: 2,
            bgcolor: 'white',
            alignItems: hasItems ? 'flex-start' : 'center',
        }),
        superior: {
            width: '100%',
        },
        iconSetting: {
            '& .MuiSvgIcon-root': {
                fontSize: '2rem'
            },
            paddingTop: '4px',
        },
        dropList: {
            display: 'flex',
            '& .MuiTypography-root': {
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
            },
        },
        categoriesContainer: {
            maxHeight: '250px',
            overflow: 'auto',
        }
    }
}